export function getCommands(state) {
  return state.command.byId;
}
